import { useTranslation } from 'react-i18next'
import { Filter } from 'lucide-react'
import { cn } from '@/utils/cn'

/** Selected topic filter: null or '' = All, otherwise the topic string from API. */
export type VideoFilter = string | null

interface VideoFiltersProps {
  /** Topics from API (distinct topic values for current language). */
  topics: string[]
  selectedFilter: VideoFilter
  onFilterChange: (filter: VideoFilter) => void
}

export default function VideoFilters({ topics, selectedFilter, onFilterChange }: VideoFiltersProps) {
  const { t } = useTranslation()
  const allLabel = t('public.videos.categories.all', 'All')
  const filters: Array<{ id: VideoFilter; label: string }> = [
    { id: null, label: allLabel },
    ...topics.map((topic) => ({ id: topic as VideoFilter, label: topic })),
  ]

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <Filter className="w-5 h-5 text-gray-500" />
      {filters.map((filter) => {
        const isSelected =
          (filter.id == null && (selectedFilter == null || selectedFilter === '')) ||
          (filter.id != null && selectedFilter === filter.id)
        return (
          <button
            key={filter.id ?? 'all'}
            onClick={() => onFilterChange(filter.id)}
            className={cn(
              'px-4 py-2 rounded-full text-sm font-medium transition-colors',
              isSelected
                ? 'bg-primary-500 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600'
            )}
          >
            {filter.label}
          </button>
        )
      })}
    </div>
  )
}


